/*******************************************************
 * ROUTES SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")

	.factory("StopAreasService", ["$http", "ENV", function ($http, ENV) {

		return {
			findCommercialStopAreaByNamePattern            : findCommercialStopAreaByNamePattern,
			findCommercialStopAreaVj                       : findCommercialStopAreaVj,
			getStopAreasOfNetwork                          : getStopAreasOfNetwork,
			getStopAreasOfLine                             : getStopAreasOfLine,
			getStopAreasOfRoute                            : getStopAreasOfRoute,
			duplicateStopAreasFromJourney                  : duplicateStopAreasFromJourney,
			mergeStopArea30m                               : mergeStopArea30m,
			findCommercialStopAreaByNamePatternArchiveMode : findCommercialStopAreaByNamePatternArchiveMode,
			getStopArea30m                                 : getStopArea30m,
			duplicateStopArea                              : duplicateStopArea
		};


		/**
         * Rechercher des points d'arrêt commerciaux par un pattern sur le nom du point d'arrêt.
         * @param pattern
         * @returns {*}
         */
		function findCommercialStopAreaByNamePattern(pattern) {
			return $http.get(ENV.API_URL + "/stop-areas/commercial?pattern=" + pattern)
				.then((response) => {
					return response.data;
				});
		}



		/**
         * Rechercher des points d'arrêt commerciaux dans un véhicule journey
         * @param pattern
         * @returns {*}
         */
		function findCommercialStopAreaVj(vjId) {
			return $http.get(ENV.API_URL + "/stop-areas/commercial/vj/" + vjId)
				.then((response) => {
					return response.data;
				});
		}


		/**
		 * Dupliquer les points d'arrêts
		 * @param journey
		 * @returns {*}
		 */
		function duplicateStopAreasFromJourney( journey)
		{
			return $http.post( ENV.API_URL + "/stop-areas/boarding/duplicateStopAreasFromJourney?journey="+journey);
		}

		function mergeStopArea30m( from, into)
		{
			return $http.post( ENV.API_URL + "/stop-areas/boarding/mergeStopArea30m?from=" + from + "&into=" + into);
		}

		/**
         * Rechercher des points d'arrêt commerciaux par un pattern sur le nom du point d'arrêt.
         * Mode archive : on passe un nom de schéma.
         * @param pattern
         * @param schemaName Schéma optionel en cas de recherche de données archivées.
         * @returns {*}
         */
		function findCommercialStopAreaByNamePatternArchiveMode(pattern, schemaName) {
			return $http.get(ENV.API_URL + "/stop-areas/commercial?pattern=" + pattern + "&schemaName=" + schemaName)
				.then(function (response) {
					return response.data;
				});
		}

		/**
         * Récupérer les points d'arrêt d'un réseau.
         * @param networkId
         * @returns {HttpPromise}
         */
		function getStopAreasOfNetwork(networkId) {
			return $http.get(ENV.API_URL + "/exploitation/reseau/" + networkId + "/points");
		}

		/**
         * Récupérer les points d'arrêt d'une ligne
         * @param lineId
         * @returns {HttpPromise}
         */
		function getStopAreasOfLine(lineId) {
			return $http.get(ENV.API_URL + "/lines/" + lineId + "/points");
		}

		/**
         * Récupérer les points d'arrêt d'un itinéraire
         * @param routeId
         * @returns {HttpPromise}
         */
		function getStopAreasOfRoute(routeId) {
			return $http.get(ENV.API_URL + "/exploitation/parcours/" + routeId + "/points");
		}

		/**
		 * Récupérer les PA à moins de 30m du PA passé en id
		 * @param id
		 * @returns {HttpPromise}
		 */
		function getStopArea30m( id)
		{
			return $http.get(ENV.API_URL + "/stop-areas/boarding/" + id + "/getstoparea30m");
		}

		function duplicateStopArea( spId, jpId)
		{
			return $http.post(ENV.API_URL + "/stop-areas/boarding/" + spId + "/duplicate/" + jpId);
		}
	}]);


